import {connect} from "react-redux"
import {breakpoints} from "@next/ux-fabric"
import {getFullHeaderHeight, getMobileScrollHeight} from "../../utils/getHeaderHeight"
import isSecurePageRequested from "../../utils/secureHeader"
import State from "../../ducks/state"
import {shouldDisplayBackToSiteBanner} from "../../utils/backToSiteBanner"
import {ENTRYPOINT_HEADER_NAME} from "../../config/constants"
import {SupportedRegionTypes} from "../../models/regions"
import checkBannerVisibility from "../../utils/checkBannerVisibility"

export const mapStateToProps = (state: State) => {
    const {
        template,
        enableContentBanner,
        secureHeaderEnabled,
        showStaticHeaderBanner,
        isCountrySelectorInGlobalAppBar,
        backToNextBannerShowAlways,
    } = state.settings
    const {url} = state.request

    const trimmedUrl = (url && (url[0] === "/" ? url.substring(1) : url)) || ""
    const isExcluded =
        (new URLSearchParams(trimmedUrl).get("excludeContentBanner")?.toLocaleLowerCase() || "") === "true"

    const showBackToSiteBanner = shouldDisplayBackToSiteBanner(
        state.data?.regions,
        state.settings.backToSiteBannerConfiguration,
        state.request.headers?.[ENTRYPOINT_HEADER_NAME],
        backToNextBannerShowAlways,
    )
    const messageBannerControls: any = state.data?.regions.find(
        region => region.type === SupportedRegionTypes.MessageBanner,
    )
    const bannerVisibility = checkBannerVisibility(
        state.data?.regions.find(region => region.type === SupportedRegionTypes.StaticBannerLinks)?.elements,
        enableContentBanner,
        state.request.url,
        messageBannerControls?.enabled,
        showStaticHeaderBanner,
        (typeof window !== "undefined" && window.innerWidth > breakpoints.values.md) || true, // Default to true for SSR
        isCountrySelectorInGlobalAppBar,
    )
    const isSecure = isSecurePageRequested(url || "") && secureHeaderEnabled
    const headerHeights = getFullHeaderHeight(
        template,
        bannerVisibility.showaAppBar,
        bannerVisibility.showCMSBanner,
        showBackToSiteBanner,
        isSecure,
    )

    const mobileScrollHeight = getMobileScrollHeight(template, showBackToSiteBanner, isSecure)

    return {
        mobileHeight: headerHeights.mobile,
        desktopHeight: headerHeights.desktop,
        mobileScrollHeight,
    }
}

export default connect(mapStateToProps)
